<template>
 <div class="wrapper">
    <div class="columns is-tablet">
      <div class="column is-12-mobile is-9-tablet pt-0">
        <back-button class="mb-5"/>
        <div class="columns is-align-items-center">
          <div class="column is-12-mobile is-10-tablet pt-0">
            
            <h1 class="is-size-5 is-size-4-desktop has-text-weight-bold mb-0 has-text-centered">
              IT Vs Open Ended
            </h1>
            <h3 class="mb-3 has-text-centered">
              compare historical returns per category
            </h3>
            <div class="is-flex is-align-items-center is-flex-direction-column">
              <b-dropdown multiple :disabled="!isLogin" aria-role="list" class="mb-2" v-model="data" @input="updateDataChart()">
                <button class="button is-primary btn-blue" slot="trigger" slot-scope="{ active }">
                    <span>Choose categories to analyse</span>
                    <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                </button>
                <b-dropdown-item aria-role="listitem" v-for="(i, index) in dataDropdown" @click="i.defaultcat = !i.defaultcat" :class="{'is-active': i.defaultcat }" :value="i" :key="index">
                  <span class="check"></span><span>{{i.categoryname}}</span>
                </b-dropdown-item>
              </b-dropdown>
              <div v-if="!isLogin" class="is-flex font-size-16" style="gap:10px">
                <a class="has-text-underline has-text-weight-bold" href="/login">Login</a> 
                <span class="has-text-weight-bold text-blue">|</span> 
                <a class="has-text-weight-bold has-text-underline" href="/register">Sign up</a> 
                to use this dropdown
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-align-items-center mb-5">
          <div class="column is-12-mobile is-10-tablet pt-0">
            <div class="wrapper-table">
              <table class="comparison-table-2">
                <thead>
                    <tr>
                        <td></td>
                        <td>
                          <table>
                            <tr><td colspan="2">1Y</td></tr>
                            <tr>
                              <td># of funds</td>
                              <td>
                                <div>weighted average NTR</div>
                                <div>{{MedianWeight == 'median' ? 'median NTR' : 'weighted average NTR'}}</div>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td>
                          <table>
                            <tr><td colspan="2">3Y</td></tr>
                            <tr>
                              <td># of funds</td>
                              <td>
                                <div>weighted average NTR</div>
                                <div>{{MedianWeight == 'median' ? 'median NTR' : 'weighted average NTR'}}</div>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td>
                          <table>
                            <tr><td colspan="2">5Y</td></tr>
                            <tr>
                              <td># of funds</td>
                              <td>
                                <div>weighted average NTR</div>
                                <div>{{MedianWeight == 'median' ? 'median NTR' : 'weighted average NTR'}}</div>
                              </td>
                            </tr>
                          </table>
                        </td>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="data in data" :key="data.id">
                    <td>
                        <table>
                            <td><a @click="searchCategory(data.categoryId, data.categoryname)">{{data.categoryname}}</a></td>
                            <td>
                              <div>IT</div>
                              <div>Open-Ended</div>
                            </td>
                        </table>
                    </td>
                    <td>
                        <table>
                            <td>
                              <div>{{data.itnumfunds1Y || '-'}}</div>
                              <div>{{data.oenumfunds1Y || '-'}}</div>
                            </td>
                            <td>
                              <div :class="{'red': parseFloat(data[`it${MedianWeight}NTR1Y`]) < 0 }">{{ data[`it${MedianWeight}NTR1Y`] ? parseFloat(data[`it${MedianWeight}NTR1Y`]).toFixed(2) + '%' : '-' }}</div>
                              <div :class="{'red': parseFloat(data[`oe${MedianWeight}NTR1Y`]) < 0 }">{{ data[`oe${MedianWeight}NTR1Y`] ? parseFloat(data[`oe${MedianWeight}NTR1Y`]).toFixed(2) + '%' : '-' }}</div>
                            </td>
                        </table>
                    </td>
                    <td>
                      <table>
                            <td>
                              <div>{{data.itnumfunds3Y || '-'}}</div>
                              <div>{{data.oenumfunds3Y || '-'}}</div>
                            </td>
                            <td>
                              <div :class="{'red': parseFloat(data[`it${MedianWeight}NTR3Y`]) < 0 }">{{ data[`it${MedianWeight}NTR3Y`] ? parseFloat(data[`it${MedianWeight}NTR3Y`]).toFixed(2) + '%' : '-' }}</div>
                              <div :class="{'red': parseFloat(data[`oe${MedianWeight}NTR3Y`]) < 0 }">{{ data[`oe${MedianWeight}NTR3Y`] ? parseFloat(data[`oe${MedianWeight}NTR3Y`]).toFixed(2) + '%' : '-' }}</div>
                            </td>
                        </table>
                    </td>
                    <td>
                      <table>
                            <td>
                              <div>{{data.itnumfunds5Y || '-'}}</div>
                              <div>{{data.oenumfunds5Y || '-'}}</div>
                            </td>
                            <td>
                              <div :class="{'red': parseFloat(data[`it${MedianWeight}NTR5Y`]) < 0 }">{{ data[`it${MedianWeight}NTR5Y`] ? parseFloat(data[`it${MedianWeight}NTR5Y`]).toFixed(2) + '%' : '-'}}</div>
                              <div :class="{'red': parseFloat(data[`oe${MedianWeight}NTR5Y`]) < 0 }">{{ data[`oe${MedianWeight}NTR5Y`] ? parseFloat(data[`oe${MedianWeight}NTR5Y`]).toFixed(2) + '%' : '-'}}</div>
                            </td>
                        </table>
                    </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="column is-12-mobile is-2-tablet">
            <label class="is-flex is-flex mt-1 is-align-items-center is-flex-direction-column is-flex-direction-row-mobile is-justify-content-center">
              <span class="has-text-centered is-block">Median <br> NTR <button v-tooltip="{content: 'Annualised Net Total Return', trigger: 'hover click'}">?</button></span>
              <b-field class="m-2">
                  <b-switch
                      true-value="wavg"
                      class="mr-0"
                      false-value="median"
                      v-model="MedianWeight"
                      @input="updateDataChart()"
                  >
                  </b-switch>
              </b-field>
              <span class="has-text-centered is-block"><span style="white-space:nowrap">Weighted *</span><br>Average<br>NTR <button v-tooltip="{content: 'Annualised Net Total Return', trigger: 'hover click'}">?</button></span>
              <div class="mt-3 is-size-7 is-hidden-mobile" style="white-space:nowrap">* Weighted by Net Assets</div>
            </label>  
            <div class="mt-3 is-size-7 has-text-centered is-hidden-tablet" style="white-space:nowrap">* Weighted by Net Assets</div> 
          </div>
        </div>
        <div class="columns is-align-items-center">
          <div class="column is-12-mobile is-10-tablet">
            <div class="wrapper-table">
              <div class="wrapper-chart">
                <BarChartHorizon :name="name" :dataNTR="dataNTR"/>
              </div>
            </div>
            <div class="wrapper-label">
              <div class="has-text-centered has-text-weight-bold mt-4" v-if="MedianWeight == 'median'">
                IT MEDIAN NTR 
                <br><span style="display: inline-block; width: 20px; border-bottom: 3px solid #153647; margin-bottom: 5px;"></span>
                <br>OE MEDIAN NTR 
                <br><br>OVER LAST {{ NTR }}</div>
              <div class="has-text-centered has-text-weight-bold mt-4" v-else>
                IT WEIGHTED AVERAGE NTR
                <br><span style="display: inline-block; width: 20px; border-bottom: 3px solid #153647; margin-bottom: 5px;"></span>
                <br>OE WEIGHTED AVERAGE NTR
                <br><br>NTR OVER LAST {{ NTR }}</div>
            </div>
          </div>
          <div class="column is-12-mobile is-2-tablet">
            <div class="is-flex is-flex-direction-column ntr-checkbox is-flex-direction-row-mobile is-justify-content-center">
              <div>
                <b-checkbox class="mb-2" v-model="Y1" 
                v-on:click.native="NTR='1Y',Y3=false,Y5=false, 
                name='IT MEDIAN NTR - OE MEDIAN NTR OVER LAST 1Y',
                updateDataChart()" 
                :disabled="Y1">
                  <span class="font-medium-mobile">1Y</span>
                </b-checkbox>
              </div>
              <div>
                <b-checkbox class="mb-2" v-model="Y3" 
                v-on:click.native="NTR='3Y',Y1=false, Y5=false, 
                name='IT MEDIAN NTR - OE MEDIAN NTR OVER LAST 3Y',
                updateDataChart()" 
                :disabled="Y3">
                  <span class="font-medium-mobile">3Y</span>
                </b-checkbox>
              </div>          
              <div>
                <b-checkbox v-model="Y5" 
                v-on:click.native="NTR='5Y', Y3=false, Y1=false,
                name='IT MEDIAN NTR - OE MEDIAN NTR OVER LAST 5Y',
                updateDataChart()" 
                :disabled="Y5">
                  <span class="font-medium-mobile">5Y</span>
                </b-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-3-tablet" ref="subRight_before">
        <div class="banner-on-top" ref="subRight">
          <AdsGoogle />
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column disclaimer">
          <Disclaimer />
      </div>
    </div>
 </div>
</template>
<script>
import BackButton from '@/components/BackButton.vue';
import Disclaimer from "@/components/Disclaimer";
import commonMixin from "@/mixins/commonMixin";
import BarChartHorizon from "@/components/BarChartHorizon";
import axios from 'axios';
import bannerMixin from "@/mixins/bannerMixin";
import AdsGoogle from '@/components/AdsGoogle.vue';
export default {
    name: 'ITOpenEnded',
    components: { BarChartHorizon, BackButton, Disclaimer, AdsGoogle },
    mixins: [commonMixin, bannerMixin],
    data: function () {
        return {
          dataDropdown: [],
          data: [],
          Y1: true,
          Y3: false,
          Y5: false,
          NTR: '1Y',
          dataNTR: null,
          MedianWeight: 'median',
          isLogin: false
        }
    },
    methods: {
      updateDataChart() {
        // let name = 'IT WEIGHTED AVERAGE NTR - OE WEIGHTED AVERAGE NTR OVER LAST '
        // if (this.MedianWeight == 'median') {
        //   name = 'IT MEDIAN NTR - OE MEDIAN NTR OVER LAST '
        // }
        this.dataNTR = {
          "data": [],
          "ticks": 1,
          "max": 10,
          "min": -10,
          // "name": name + this.NTR,
          "name": "",
          "list": []
        }
        for (let i = 0; i < this.data.length; i++) {
          let value = parseFloat(this.data[i]['it'+this.MedianWeight+'NTR' + this.NTR]) - parseFloat(this.data[i]['oe'+this.MedianWeight+'NTR' + this.NTR])
          this.dataNTR.data.push({
            "x": value,
            "y": i + 1
          })
          this.dataNTR.list.push(this.data[i].categoryname)
          if (value > this.dataNTR.max) {
            this.dataNTR.max = value
          }
          if (value < this.dataNTR.min) {
            this.dataNTR.min = value
          }
        }
      },
      async searchCategory(typeFund, typeCategory) {
        await this.resetSearchResults();
        await this.$store.dispatch("search/apiCall", {
            "fund": typeCategory,
            "type": "category",
            "text": typeCategory,
            "code": [typeFund],
            "source": 5,
        });

        this.$store.commit("search/SET_ABSOLUTETOTAL", this.$store.state.search.searchData.total)
        this.$store.commit("search/SET_NEW_SEARCH_SECTION", true)

        const textURL = this.convertURL(typeCategory.replaceAll('/', '*'))
        window.scrollTo(0,0);
        await this.$router.push({name:"Results", params: {id: this.$store.state.search.searchData.searchdata_id, text: textURL}})
      },
      resetSearchResults() {
        this.$store.commit("search/SET_CURRENT_PAGE",1)
        this.$store.commit("search/SET_FILTERS",{})
        this.$store.commit("search/SET_PROV_FILTERS",{})
        this.$store.commit("search/SET_PROVISIONAL_RES",{})
        this.$store.commit("search/SET_COUNT_BASIC", 0);
        this.$store.commit("search/SET_COUNT_ADVANCE", 0);
        this.$store.commit("search/SET_SORTDIR1","DESC")
        this.$store.commit("search/SET_SORTDIR2","DESC")
        this.$store.commit("search/SET_SORTING1","CumulativeTotalReturn1Year")
        this.$store.commit("search/SET_SORTING2",null)
        this.$store.commit("search/SET_SHOW_SECOND_OPTION", false);
      }
    },
    mounted(){
      this.updateDataChart();
    },
    metaInfo() {
        return {
            title: 'Investment Trusts vs Open Ended Funds: compare track records',
            meta: [
                { name: 'description', content:  'Choose a fund category and compare the performance of Investment Trusts vs Open Ended Funds over different time horizons.'},
            ],
        }
    },
    created() {
      var self = this;
      axios.get("/investment-trust-vs-open-ended").then(response => {
          if (response.data.length) {
            self.dataDropdown = response.data.sort((a, b) => a.categoryname.localeCompare(b.categoryname));
            self.data = self.dataDropdown.filter(item => item.defaultcat === true);
            self.updateDataChart();
          }
      });window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    watch: {
        '$store.state.auth.authenticated': function (data) {
            if(data) this.isLogin = true;
        },
    }
}
</script>
<style scoped lang="scss">
.dropdown.is-disabled {
  opacity: 1 !important;
}
::v-deep .mdi-24px.mdi:before {
  color: #fff;
}
.btn-blue {
    background-color: #4173ea !important;
    color: #fff !important;
}
.about-video {
    @media (min-width: 768px) {
        margin-top: -78px;
    }
}
.comparison-table-2 table {
  box-shadow: none;
  border: none;
  border-radius: 0;
}
.comparison-table-2 > thead > tr > td {
  border-right: 1px solid #fff;
  padding: 0;
} 
.comparison-table-2 > thead > tr > td:last-child {
  border-right: none;
} 
.comparison-table-2 > thead > tr > td > table tr:first-child > td {
  border-bottom: 1px solid #fff;
  padding: 5px;
}
.comparison-table-2 > thead > tr > td > table tr:nth-child(2) > td:first-child {
  border-right: 1px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.comparison-table-2 > thead > tr > td > table tr:nth-child(2) > td {
  width: 50%;
}
table.comparison-table-2 tbody tr:first-child td {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
table.comparison-table-2 tbody tr:first-child td:first-child {
  border-left: none;
  padding: 0;
}
table.comparison-table-2 tbody tr:first-child td:last-child {
  border-right: none;
}
table.comparison-table-2 tbody td table td {
  width: 50%;
}
table.comparison-table-2 tbody tr td {
  vertical-align: middle;
  text-align: center !important;
  padding: 0;
}
table.comparison-table-2 tbody tr td table div:first-child {
  border-bottom: 1px solid #fff;
} 
table.comparison-table-2 tbody tr td table > td {
  border: none;
}
table.comparison-table-2 tbody tr table > td {
  border-top: none !important;
  border-bottom: none !important;
}
table.comparison-table-2 tbody tr table > td:first-child {
  border-right: 1px solid #ddd;
}
table.comparison-table-2 tbody tr table > td div:first-child {
  border-bottom: 1px solid #ddd;
}
table.comparison-table-2 tbody tr table > td div {
  padding: 10px;
}
.ntr-checkbox ::v-deep label{
  opacity: 1 !important;
  color: inherit;
}
::v-deep .switch.is-rounded input[type=checkbox] + .check {
  background: linear-gradient(180deg, #4173ea 0%, #41bcea 100%);
}
::v-deep .switch.is-rounded input[type=checkbox]:checked + .check {
  background: linear-gradient(180deg, #2abe23 0%, #34e92b 100%);
}
.comparison-table-2 tr td {
  position: relative;
  vertical-align: middle;
}
.comparison-table-2 thead td div:first-child {
  opacity: 0;
}
.comparison-table-2 thead td div:last-child {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.25em 0.75em;
}
table.comparison-table-2 tbody tr td:first-child table td:first-child {
  padding: 5px;
  text-wrap: wrap;
}
table.comparison-table-2 tbody tr td:first-child table td  {
  height: 100%;
}
table {
  height: 100%;
}
table.comparison-table-2 tbody tr td:not(:first-child) table td {
  height: 100%;
}
table.comparison-table-2 tbody tr td:not(:first-child) table td div,
table.comparison-table-2 tbody tr td:first-child table td:last-child div {
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
table.comparison-table-2 > tbody > tr > td:first-child {
  font-weight: bold;
}
table.comparison-table-2 > thead > tr > td > table tr:nth-child(2) {
  display: flex;
}
.wrapper-table {
  overflow-x: auto;
}
.wrapper-table > .wrapper-chart {
  min-width: 600px;
}
.is-flex-direction-row-mobile {
  @media (max-width: 767px) {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
}
</style>